<template>
  <div>
    <app-header></app-header>

    <v-container>
      <div
        class="text-h2 font-weight-thin text-center info--text text--lighten-1"
        style="letter-spacing: 10px !important; position: relative"
      >
        <span v-if="user && user.animate">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="258"
            height="60"
            style="position: absolute"
            class="drawCon"
          >
            <!-- text PDA -->
            <path
              class="pathFolder"
              :style="{
                strokeWidth: 3,
                strokeDasharray: 125,
                strokeDashoffset: 125,
              }"
              d="M7 52 v -41 h6 c22,0 22,23 0,23 h -6 
              M85 11 v41 
              M140 51 c24.3,8.3 32.3,-15.2 11.9,-20 C 131.6,27.7 139.7,3.9 162.1,12.5 
              M213, 52 l16.5, -41 l16.5, 41 l -7, -15 h -20"
            />
          </svg>
        </span>
        <v-badge class="btnCon" content="V2.0" overlap color=" info lighten-1">
          P•I•S•A
        </v-badge>
        <div
          class="d-none d-sm-block"
          style="font-size: 20px; margin-top: -15px"
        >
          Pausch Informationssystem für Alle
        </div>
      </div>

      <!-- user apps -->
      <v-row justify="center">
        <v-col cols="10">
          <!-- Error message -->
          <my-message type="error"></my-message>
          <!-- apps -->
          <v-row justify="center" class="mt-3">
            <v-col
              class="
                col-xl-2 col-lg-3 col-md-4 col-sm-4 col-6
                py-5
                app-con
                text-center
              "
              v-for="(app, a) in getUserApps"
              :key="a"
              @click="$router.push('/' + app.id)"
            >
              <!-- drawing -->
              <svg
                v-if="user.animate == 1 && drawings[app.id]"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 80 80"
                style="
                  position: absolute;
                  top: 5px;
                  left: 5px;
                  width: calc(100% - 10px);
                  height: calc(100% - 10px);
                "
                class="drawCon"
              >
                <!-- rectangle -->
                <path
                  class="pathFolder"
                  :style="{
                    strokeWidth: 0.2,
                    stroke: '#e5e5e5',
                    strokeDasharray: 308,
                    strokeDashoffset: 308,
                  }"
                  :d="
                    'M 0 3 l ' +
                    lineLength +
                    ' 0 l 0 ' +
                    (lineLength - 6) +
                    ' l ' +
                    -lineLength +
                    ' 0 l 0 ' +
                    -(lineLength - 6)
                  "
                />
                <!-- icon -->
                <path
                  :transform="'translate(' + 28 + ', ' + 6 + ')'"
                  class="pathFolder"
                  :style="{
                    strokeWidth: 0.5,
                    strokeDasharray: drawings[app.id].stroke,
                    strokeDashoffset: drawings[app.id].stroke,
                  }"
                  :d="drawings[app.id].path"
                />
                <!-- title -->
                <path
                  class="pathFolder"
                  fill="#0070f3"
                  :style="{
                    strokeWidth: 8,
                    strokeDasharray: drawings[app.id].title,
                    strokeDashoffset: drawings[app.id].title,
                  }"
                  :d="
                    'm' +
                    (lineLength / 2 - drawings[app.id].title / 2) +
                    ',41 h' +
                    drawings[app.id].title
                  "
                />
                <!-- line -->
                <path
                  class="pathFolder"
                  :style="{
                    strokeWidth: 0.5,
                    strokeDasharray: lineLength,
                    strokeDashoffset: lineLength,
                  }"
                  :d="'M 0 51 h ' + lineLength"
                />
                <!-- description -->
                <template v-for="(draw, d) in drawings[app.id].desc">
                  <path
                    :key="d"
                    class="pathFolder"
                    :style="{
                      strokeWidth: 4,
                      strokeDasharray: draw.stroke,
                      strokeDashoffset: draw.stroke,
                    }"
                    :d="draw.line + draw.stroke"
                  />
                </template>
              </svg>
              <!-- buttons -->
              <span class="btnCon">
                <v-btn
                  v-if="app.docu != ''"
                  small
                  absolute
                  right
                  top
                  icon
                  class="mr-n1 mt-n1"
                  title="Anleitung"
                  :href="path + app.docu"
                  target="_blank"
                  @click.stop="saveUserClick({ app: app.id, page: 'Manual' })"
                >
                  <v-icon small class="info--text text--darken-1"
                    >mdi-information-outline</v-icon
                  >
                </v-btn>

                <v-icon
                  :color="app.color"
                  :style="
                    $vuetify.breakpoint.smAndUp
                      ? 'font-size: 70px'
                      : 'font-size: 50px'
                  "
                >
                  {{ app.icon }}
                </v-icon>
                <div class="app-title accent--text text--darken-1">
                  <span>{{ app.title }}</span>
                </div>
                <div class="app-desc d-none d-sm-block font-weight-light">
                  {{ app.desc }}
                </div>
                <div v-if="app.disabled" class="appcon_disabled" @click.stop>
                  <div id="disabled">Gesperrt</div>
                </div>
              </span>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>

    <!-- dialog new password -->
    <v-dialog v-model="dialog" persistent width="350">
      <v-card>
        <v-card-title class="blue accent-1">
          <span class="text-h4 white--text">Change password</span>
        </v-card-title>
        <v-card-text>
          <v-form
            id="changePW"
            class="mt-6"
            v-model="valid"
            lazy-validation
            ref="form"
          >
            <v-text-field
              :type="showPwd ? 'text' : 'password'"
              v-model="oldPwd"
              label="current password"
              required
              :rules="[(v) => !!v || 'current password required']"
            >
            </v-text-field>
            <v-text-field
              :type="showPwd ? 'text' : 'password'"
              v-model="newPwd_1"
              label="new password"
              required
              :rules="[
                (v) => !!v || 'new password required',
                (v) => v != oldPwd || 'a new password must be assigned',
              ]"
            >
            </v-text-field>
            <v-text-field
              :type="showPwd ? 'text' : 'password'"
              v-model="newPwd_2"
              label="repeat new password"
              required
              :rules="[
                (v) => !!v || 'new password required',
                (v) => v == newPwd_1 || 'new password must be the same',
              ]"
            >
            </v-text-field>
          </v-form>
          <!-- errMsg -->
          <v-alert v-if="errMsg != ''" text type="error" class="mt-10">
            {{ errMsg }}
          </v-alert>
        </v-card-text>

        <v-card-actions>
          <v-icon class="accent--text" @click="showPwd = !showPwd">
            {{ showPwd ? 'mdi-eye' : 'mdi-eye-off' }}
          </v-icon>
          <v-spacer></v-spacer>
          <v-btn
            type="submit"
            form="changePW"
            color="success"
            text
            @click.prevent="saveNewPW"
          >
            save new password
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- screen saver -->
    <smiley v-if="showSS"></smiley>

    <!-- cronjob messages -->
    <div id="cronjob" class="cron">
      <div v-for="(msg, m) in messages" :key="m">
        <small>{{ msg }}</small>
      </div>
    </div>
  </div>
</template>

<script>
import AppHeader from './Header.vue'
import Smiley from '@/components/Smiley.vue'

import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  data() {
    return {
      path: process.env.VUE_APP_HOME,
      dialog: false,
      valid: true,
      oldPwd: '',
      newPwd_1: '',
      newPwd_2: '',
      showPwd: false,
      errMsg: '',
      messages: [],
      showInfo: false,

      drawings: {
        crm: {
          path: 'M21 13.1C20.9 13.1 20.7 13.2 20.6 13.3L19.6 14.3L21.7 16.4L22.7 15.4C22.9 15.2 22.9 14.8 22.7 14.6L21.4 13.3C21.3 13.2 21.2 13.1 21 13.1M19.1 14.9L13 20.9V23H15.1L21.2 16.9L19.1 14.9M21 3H13V9H21V3M19 7H15V5H19V7M13 18.06V11H21V11.1C20.24 11.1 19.57 11.5 19.19 11.89L18.07 13H15V16.07L13 18.06M11 3H3V13H11V3M9 11H5V5H9V11M11 20.06V15H3V21H11V20.06M9 19H5V17H9V19Z',
          stroke: 36,
          title: 50 / 3,
          desc: [
            { line: 'm9,57 h ', stroke: 22 },
            { line: 'm36,57 h ', stroke: 3 },
            { line: 'm44,57 h ', stroke: 17 },
            { line: 'm66,57 h ', stroke: 5 },
            { line: 'm7,64 h ', stroke: 22 },
            { line: 'm34,64 h ', stroke: 4 },
            { line: 'm43,64 h ', stroke: 23 },
            { line: 'm71,64 h ', stroke: 2 },
            { line: 'm21,71 h ', stroke: 14 },
            { line: 'm40,71 h ', stroke: 19 },
          ],
        },
        draw: {
          path: 'M14,2L20,8V20A2,2 0 0,1 18,22H6A2,2 0 0,1 4,20V4A2,2 0 0,1 6,2H14M18,20V9H13V4H6V20H18M17,13V19H7L12,14L14,16M10,10.5A1.5,1.5 0 0,1 8.5,12A1.5,1.5 0 0,1 7,10.5A1.5,1.5 0 0,1 8.5,9A1.5,1.5 0 0,1 10,10.5Z',
          stroke: 66,
          title: 98 / 3,
          desc: [
            { line: 'm14,57 h ', stroke: 13 },
            { line: 'm32,57 h ', stroke: 4 },
            { line: 'm41,57 h ', stroke: 25 },
            { line: 'm19,64 h ', stroke: 32 },
            { line: 'm56,64 h ', stroke: 5 },
            { line: 'm22,71 h ', stroke: 36 },
          ],
        },
        elvira: {
          path: 'M19 1L14 6V17L19 12.5V1M21 5V18.5C19.9 18.15 18.7 18 17.5 18C15.8 18 13.35 18.65 12 19.5V6C10.55 4.9 8.45 4.5 6.5 4.5C4.55 4.5 2.45 4.9 1 6V20.65C1 20.9 1.25 21.15 1.5 21.15C1.6 21.15 1.65 21.1 1.75 21.1C3.1 20.45 5.05 20 6.5 20C8.45 20 10.55 20.4 12 21.5C13.35 20.65 15.8 20 17.5 20C19.15 20 20.85 20.3 22.25 21.05C22.35 21.1 22.4 21.1 22.5 21.1C22.75 21.1 23 20.85 23 20.6V6C22.4 5.55 21.75 5.25 21 5M10 18.41C8.75 18.09 7.5 18 6.5 18C5.44 18 4.18 18.19 3 18.5V7.13C3.91 6.73 5.14 6.5 6.5 6.5C7.86 6.5 9.09 6.73 10 7.13V18.41Z',
          stroke: 103,
          title: 56 / 3,
          desc: [
            { line: 'm14,57 h ', stroke: 15 },
            { line: 'm34,57 h ', stroke: 22 },
            { line: 'm61,57 h ', stroke: 5 },
            { line: 'm14,64 h ', stroke: 35 },
            { line: 'm54,64 h ', stroke: 12 },
          ],
        },
        fpm: {
          path: 'M19 2L14 6.5V17.5L19 13V2M6.5 5C4.55 5 2.45 5.4 1 6.5V21.16C1 21.41 1.25 21.66 1.5 21.66C1.6 21.66 1.65 21.59 1.75 21.59C3.1 20.94 5.05 20.5 6.5 20.5C8.45 20.5 10.55 20.9 12 22C13.35 21.15 15.8 20.5 17.5 20.5C19.15 20.5 20.85 20.81 22.25 21.56C22.35 21.61 22.4 21.59 22.5 21.59C22.75 21.59 23 21.34 23 21.09V6.5C22.4 6.05 21.75 5.75 21 5.5V19C19.9 18.65 18.7 18.5 17.5 18.5C15.8 18.5 13.35 19.15 12 20V6.5C10.55 5.4 8.45 5 6.5 5Z',
          stroke: 103,
          title: 47 / 3,
          desc: [
            { line: 'm14,57 h ', stroke: 15 },
            { line: 'm34,57 h ', stroke: 22 },
            { line: 'm61,57 h ', stroke: 5 },
            { line: 'm13,64 h ', stroke: 35 },
            { line: 'm53,64 h ', stroke: 14 },
          ],
        },
        mess: {
          path: 'M13.78 15.3L19.78 21.3L21.89 19.14L15.89 13.14L13.78 15.3M17.5 10.1C17.11 10.1 16.69 10.05 16.36 9.91L4.97 21.25L2.86 19.14L10.27 11.74L8.5 9.96L7.78 10.66L6.33 9.25V12.11L5.63 12.81L2.11 9.25L2.81 8.55H5.62L4.22 7.14L7.78 3.58C8.95 2.41 10.83 2.41 12 3.58L9.89 5.74L11.3 7.14L10.59 7.85L12.38 9.63L14.2 7.75C14.06 7.42 14 7 14 6.63C14 4.66 15.56 3.11 17.5 3.11C18.09 3.11 18.61 3.25 19.08 3.53L16.41 6.2L17.91 7.7L20.58 5.03C20.86 5.5 21 6 21 6.63C21 8.55 19.45 10.1 17.5 10.1Z',
          stroke: 97,
          title: 103 / 3,
          desc: [
            { line: 'm7,57 h ', stroke: 6 },
            { line: 'm18,57 h ', stroke: 5 },
            { line: 'm28,57 h ', stroke: 19 },
            { line: 'm52,57 h ', stroke: 3 },
            { line: 'm60,57 h ', stroke: 12 },
            { line: 'm25,64 h ', stroke: 5 },
            { line: 'm35,64 h ', stroke: 20 },
          ],
        },
        noac: {
          path: 'M12,9.5L13.2,13.5L16,16.5L12,15.6L7.9,16.5L10.7,13.5L12,9.5M12,2.6L9,12.4L2,19.9L12,17.6L22,20L15,12.5L12,2.6Z',
          stroke: 62,
          title: 58 / 3,
          desc: [
            { line: 'm5,57 h ', stroke: 15 },
            { line: 'm25,57 h ', stroke: 12 },
            { line: 'm42,57 h ', stroke: 33 },
          ],
        },
        otrs: {
          path: 'M22,3H2C0.91,3.04 0.04,3.91 0,5V19C0.04,20.09 0.91,20.96 2,21H22C23.09,20.96 23.96,20.09 24,19V5C23.96,3.91 23.09,3.04 22,3M22,19H2V5H22V19M14,17V15.75C14,14.09 10.66,13.25 9,13.25C7.34,13.25 4,14.09 4,15.75V17H14M9,7A2.5,2.5 0 0,0 6.5,9.5A2.5,2.5 0 0,0 9,12A2.5,2.5 0 0,0 11.5,9.5A2.5,2.5 0 0,0 9,7M14,7V8H20V7H14M14,9V10H20V9H14M14,11V12H18V11H14',
          stroke: 81,
          title: 106 / 3,
          desc: [
            { line: 'm5,57 h ', stroke: 13 },
            { line: 'm23,57 h ', stroke: 5 },
            { line: 'm33,57 h ', stroke: 9 },
            { line: 'm47,57 h ', stroke: 2 },
            { line: 'm54,57 h ', stroke: 14 },
            { line: 'm73,57 h ', stroke: 2 },
          ],
        },
        pda: {
          path: 'M20 21H4V10H6V19H18V10H20V21M3 3H21V9H3V3M9.5 11H14.5C14.78 11 15 11.22 15 11.5V13H9V11.5C9 11.22 9.22 11 9.5 11M5 5V7H19V5H5Z',
          stroke: 72,
          title: 45 / 3,
          desc: [
            { line: 'm12,57 h ', stroke: 12 },
            { line: 'm29,57 h ', stroke: 24 },
            { line: 'm58,57 h ', stroke: 9 },
          ],
        },
        plan: {
          path: 'M6,16.5L3,19.44V11H6M11,14.66L9.43,13.32L8,14.64V7H11M16,13L13,16V3H16M18.81,12.81L17,11H22V16L20.21,14.21L13,21.36L9.53,18.34L5.75,22H3L9.47,15.66L13,18.64',
          stroke: 52,
          title: 119 / 3,
          desc: [
            { line: 'm14,57 h ', stroke: 27 },
            { line: 'm46,57 h ', stroke: 5 },
            { line: 'm56,57 h ', stroke: 9 },
            { line: 'm28,64 h ', stroke: 24 },
          ],
        },
        prm: {
          path: 'M21.71 8.71C22.96 7.46 22.39 6 21.71 5.29L18.71 2.29C17.45 1.04 16 1.61 15.29 2.29L13.59 4H11C9.1 4 8 5 7.44 6.15L3 10.59V14.59L2.29 15.29C1.04 16.55 1.61 18 2.29 18.71L5.29 21.71C5.83 22.25 6.41 22.45 6.96 22.45C7.67 22.45 8.32 22.1 8.71 21.71L11.41 19H15C16.7 19 17.56 17.94 17.87 16.9C19 16.6 19.62 15.74 19.87 14.9C21.42 14.5 22 13.03 22 12V9H21.41L21.71 8.71M20 12C20 12.45 19.81 13 19 13L18 13L18 14C18 14.45 17.81 15 17 15L16 15L16 16C16 16.45 15.81 17 15 17H10.59L7.31 20.28C7 20.57 6.82 20.4 6.71 20.29L3.72 17.31C3.43 17 3.6 16.82 3.71 16.71L5 15.41V11.41L7 9.41V11C7 12.21 7.8 14 10 14S13 12.21 13 11H20V12M20.29 7.29L18.59 9H11V11C11 11.45 10.81 12 10 12S9 11.45 9 11V8C9 7.54 9.17 6 11 6H14.41L16.69 3.72C17 3.43 17.18 3.6 17.29 3.71L20.28 6.69C20.57 7 20.4 7.18 20.29 7.29Z',
          stroke: 66,
          title: 49 / 3,
          desc: [
            { line: 'm5,57 h ', stroke: 53 },
            { line: 'm63,57 h ', stroke: 11 },
            { line: 'm11,64 h ', stroke: 4 },
            { line: 'm20,64 h ', stroke: 15 },
            { line: 'm40,64 h ', stroke: 29 },
            { line: 'm21,71 h ', stroke: 16 },
            { line: 'm42,71 h ', stroke: 5 },
            { line: 'm52,71 h ', stroke: 7 },
          ],
        },
        psp: {
          path: 'M7 11H9V13H7V11M21 5V19C21 20.11 20.11 21 19 21H5C3.89 21 3 20.1 3 19V5C3 3.9 3.9 3 5 3H6V1H8V3H16V1H18V3H19C20.11 3 21 3.9 21 5M5 7H19V5H5V7M19 19V9H5V19H19M15 13V11H17V13H15M11 13V11H13V13H11M7 15H9V17H7V15M15 17V15H17V17H15M11 17V15H13V17H11Z',
          stroke: 77,
          title: 41 / 3,
          desc: [
            { line: 'm16,57 h ', stroke: 13 },
            { line: 'm34,57 h ', stroke: 18 },
            { line: 'm57,57 h ', stroke: 6 },
          ],
        },
        ptb: {
          path: 'M19.31 18.9C19.75 18.21 20 17.38 20 16.5C20 14 18 12 15.5 12S11 14 11 16.5 13 21 15.5 21C16.37 21 17.19 20.75 17.88 20.32L21 23.39L22.39 22L19.31 18.9M15.5 19C14.12 19 13 17.88 13 16.5S14.12 14 15.5 14 18 15.12 18 16.5 16.88 19 15.5 19M9.59 19.2L3 14.07L4.62 12.81L9 16.22C9 16.32 9 16.41 9 16.5C9 17.46 9.22 18.38 9.59 19.2M9.5 14.04L3 9L12 2L21 9L18.66 10.82C17.96 10.44 17.19 10.18 16.37 10.07L17.74 9L12 4.53L6.26 9L10.53 12.32C10.1 12.84 9.74 13.42 9.5 14.04Z',
          stroke: 60,
          title: 83 / 3,
          desc: [
            { line: 'm4,57 h ', stroke: 25 },
            { line: 'm34,57 h ', stroke: 5 },
            { line: 'm44,57 h ', stroke: 18 },
            { line: 'm67,57 h ', stroke: 8 },
            { line: 'm7,64 h ', stroke: 14 },
            { line: 'm26,64 h ', stroke: 26 },
            { line: 'm57,64 h ', stroke: 4 },
            { line: 'm66,64 h ', stroke: 7 },
          ],
        },
        qmd: {
          path: 'M13,9H11V7H13M13,17H11V11H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z',
          stroke: 63,
          title: 97 / 3,
          desc: [
            { line: 'm18,57 h ', stroke: 44 },
            { line: 'm25,64 h ', stroke: 29 },
          ],
        },
        search: {
          path: 'M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z',
          stroke: 58,
          title: 113 / 3,
          desc: [
            { line: 'm19,57 h ', stroke: 13 },
            { line: 'm37,57 h ', stroke: 4 },
            { line: 'm46,57 h ', stroke: 14 },
            { line: 'm4,64 h ', stroke: 26 },
            { line: 'm35,64 h ', stroke: 4 },
            { line: 'm44,64 h ', stroke: 10 },
            { line: 'm59,64 h ', stroke: 17 },
            { line: 'm24,71 h ', stroke: 32 },
          ],
        },
        time: {
          path: 'M12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22C6.47,22 2,17.5 2,12A10,10 0 0,1 12,2M12.5,7V12.25L17,14.92L16.25,16.15L11,13V7H12.5Z',
          stroke: 63,
          title: 41 / 3,
          desc: [{ line: 'm28,57 h ', stroke: 24 }],
        },
        uro: {
          path: 'M11,2V3C9.27,3.2 7.69,3.9 6.4,4.94L5.64,4.18L4.22,5.6L5,6.35C3.9,7.68 3.21,9.3 3,11H2V13H3C3.21,14.68 3.9,16.26 5,17.56L4.22,18.32L5.64,19.74L6.39,19C7.71,20.07 9.3,20.77 11,21V22H13V21C14.69,20.77 16.29,20.07 17.6,19L18.36,19.74L19.78,18.32L19,17.57C20.1,16.27 20.79,14.68 21,13H22V11H21C20.79,9.3 20.1,7.69 19,6.36L19.78,5.6L18.36,4.18L17.61,4.94C16.29,3.87 14.69,3.2 13,3V2H11M11,5V8L10,8.5L7.81,6.35C8.72,5.67 9.81,5.17 11,5M13,5C14.16,5.18 15.26,5.64 16.2,6.35L14,8.5L13,8V5M6.4,7.76L8.5,10L8,11H5C5.16,9.84 5.7,8.7 6.39,7.75L6.4,7.76M17.6,7.76C18.33,8.71 18.81,9.82 19,11H16L15.5,10L17.61,7.76H17.6M12,10C13.12,10 14,10.88 14,12C14,13.12 13.12,14 12,14C10.88,14 10,13.12 10,12C10,10.88 10.88,10 12,10M5,13H8L8.57,14L6.39,16.15C5.67,15.24 5.19,14.16 5,13V13M16,13H19C18.81,14.15 18.33,15.24 17.61,16.16L15.5,14L16,13M10,15.5L11,16V19C9.83,18.8 8.73,18.31 7.8,17.57L10,15.5M14,15.5L16.19,17.57C15.28,18.25 14.19,18.83 13,19V16L14,15.5Z',
          stroke: 75,
          title: 70 / 3,
          desc: [{ line: 'm10,57 h ', stroke: 61 }],
        },
      },
      lineLength: 80,
    }
  },
  mounted() {
    // set favicon
    var favicon = document.querySelector("link[rel*='icon']")
    favicon.href = '/favicon.ico'

    if (this.user.animate == 1) {
      document.getElementsByClassName('btnCon').forEach((el) => {
        el.style.opacity = 0
      })
    }
  },
  created() {
    // no app rights
    if (this.getUserApps.length == 0)
      this.setMessage(
        'Benutzer hat keine App-Berechtigungen oder wurde gesperrt.'
      )

    // check new ext user
    if (this.user.newPW) this.dialog = true

    // run cronjobs
    this.$store.dispatch('isCronjob').then((res) => {
      if (res == true) {
        const crons = ['crm', 'mess', 'pda', 'prm', 'psp']

        let promises = []
        crons.forEach((cron) => {
          promises.push(
            new Promise((resolve) => {
              resolve(this[cron + 'Cron'](this.appValue(cron, 'options')))
            })
          )
        })

        Promise.all(promises).then(() => {
          document.getElementById('cronjob')?.classList.add('cron-hide')
        })
      }
    })
  },
  computed: {
    ...mapGetters(['message', 'user', 'getUserApps', 'appValue']),
    showSS() {
      return this.user?.screenSaver == 1 ? true : false
    },
  },
  methods: {
    ...mapMutations(['setUser', 'setMessage']),
    ...mapActions(['saveUserClick']), // for visit manuals
    saveNewPW() {
      if (this.$refs.form.validate()) {
        this.$axios
          .put('pisa/user/pwd', {
            userId: this.user.id,
            oldPwd: this.oldPwd,
            newPwd: this.newPwd_1,
          })
          .then((res) => {
            if (res.data) {
              this.dialog = false
              this.user.newPW = false
              // this.setUser(this.user)
            } else this.errMsg = 'Aktuelles Passwort falsch!'
          })
      }
    },
    // cronjobs
    crmCron(opt) {
      // send request reminder for older then 'opt.third' days
      return this.$axios.get('crm/cronjob/' + opt.third).then((res) => {
        return this.messages.push('CRM => ' + res.data)
      })
    },
    messCron(opt) {
      // send weekly mail for mess check
      if (
        this.moment().isoWeekday() === 1 &&
        this.moment().isSameOrAfter(this.moment(opt.date), 'day')
      ) {
        return this.$axios.get('mess/cronjob').then((res) => {
          return this.messages.push('MESS => ' + res.data)
        })
      } else return false
    },
    pdaCron(opt) {
      // send new archived drawings
      return this.$axios
        .get('pda/cronjob', { params: { user: opt.drawInfo } })
        .then((res) => {
          return this.messages.push('PDA => ' + res.data)
        })
    },
    prmCron(opt) {
      // send weekly list with open complaints
      if (
        this.moment().isoWeekday() === 1 &&
        this.moment().isSameOrAfter(this.moment(opt.checkLastStep), 'day')
      ) {
        return this.$axios.get('prm/cronjob', { params: opt }).then((res) => {
          return this.messages.push('PRM => ' + res.data)
        })
      } else return false
    },
    pspCron(opt) {
      // send weekly mail with missing documents
      if (
        this.moment().isoWeekday() === 1 &&
        this.moment().isSameOrAfter(this.moment(opt.date), 'day')
      ) {
        return this.$axios.get('psp/cronjob/' + opt.date).then((res) => {
          return this.messages.push('PSP => ' + res.data)
        })
      } else return false
    },
  },

  components: {
    AppHeader,
    Smiley,
  },
}
</script>

<style>
:root {
  /* --lineLengthFolder: 36; */
  --lineTime: 1s;
  --blendTime: 2s;
}
</style>

<style scoped>
.cron {
  position: absolute;
  top: 200px;
  left: 16px;
  opacity: 1;
  transition: opacity 10s;
  font-size: 12px;
  color: #999;
}

.cron-hide {
  opacity: 0;
}

/* Apps Layout */
.app-con {
  border: 1px solid transparent;
  cursor: pointer;
  position: relative;
}

.app-con:hover {
  border: 1px solid #e5e5e5;
  border-radius: 4px;
}

.app-con .app-title {
  margin: 10px 5px;
  /* color: #428bca; */
  text-shadow: 1px 1px 3px #808080;
  font-variant: small-caps;
  font-size: 24px;
  font-weight: 300;
}

.app-con .app-desc {
  height: 65px;
  font-size: 13px;
  border-top: 1px solid #428bca;
  padding: 5px 5px 0;
  margin-bottom: 0;
  color: #737373;
}

.appcon_disabled {
  position: absolute;
  width: 101%;
  height: 233px;
  top: -1px;
  left: -1px;
  background: #fff;
  opacity: 0.8;
  cursor: no-drop;
}

#disabled {
  transform: skew(-20deg) rotate(-20deg);
  margin-top: 80px;
  font-size: 30px;
  font-weight: bold;
  font-variant: small-caps;
}

/* drawing */
.pathFolder {
  /* stroke-width: 1; */
  stroke: #428bca;
  /* stroke: #51b0ff; */
  stroke-linejoin: round;
  stroke-linecap: round;
  fill: white;
  /* stroke-dasharray: var(--lineLengthFolder); */
  /* stroke-dashoffset: var(--lineLengthFolder); */
  animation-duration: var(--lineTime);
  animation-timing-function: linear;
  /* animation-delay: 0.2s; */
  animation-fill-mode: forwards;
  animation-name: dash;
}

@keyframes dash {
  to {
    stroke-dashoffset: 0;
  }
}

.drawCon {
  opacity: 1;
  animation-duration: var(--blendTime);
  animation-delay: var(--lineTime);
  animation-fill-mode: forwards;
  animation-name: hideDraw;
}

@keyframes hideDraw {
  to {
    opacity: 0;
  }
}

.btnCon {
  /* opacity: 0; */
  animation-duration: var(--blendTime);
  animation-delay: var(--lineTime);
  animation-fill-mode: forwards;
  animation-name: showBtn;
}

@keyframes showBtn {
  to {
    opacity: 1;
  }
}
</style>
